import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import * as API from "../../../api/billing";
import moment from "moment";
import { Breadcrumb } from "react-bootstrap";
import "./style.css";
// import { Button } from "react-bootstrap";
// import { color } from "highcharts";

const BillPaymentDetails = () => {
    const location = useLocation();
    const navigate = useHistory();
    const row = location.state?.row;

    const [billData, setBillData] = useState([]);
    const [billPaymentData, setPaymentData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBillDetails = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await API.getBillDetails(row.billNumber);
                setBillData(response?.data?.data || []);
                setPaymentData(response?.data?.billPayments || []);
            } catch (err) {
                setError(err.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        if (row?.billNumber) {
            fetchBillDetails();
        }
    }, [row]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!billData.length) return <p>No billing records found.</p>;

    const formatAmount = (amount) => {
        if (amount === null || amount === undefined || amount === "" || isNaN(amount)) {
            return "₹0";
        }
        return `₹${amount}`;
    };

    return (
        <div style={{ padding: "20px", fontFamily: "Arial" }}>
            {/* Heading */}
            <h2 style={{ textAlign: "center", marginBottom: "30px", fontWeight: "bold" }}>
                Bill Summary
            </h2>

            {/* ✅ Breadcrumb instead of Back Button */}
            <Breadcrumb style={{ marginBottom: "20px" }}>
                <Breadcrumb.Item onClick={() => navigate.push("/billing")}>
                    Billing
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Billing Details</Breadcrumb.Item>
            </Breadcrumb>

            {/* Back Button */}
            {/* <Button
                variant="light"
                onClick={() => navigate.goBack()}
                className="rounded-circle p-0 shadow-sm border"
                style={{
                    width: 40,
                    height: 40,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                }}
                aria-label="Go back"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H3.707l3.147 
        3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 
        0-.708l4-4a.5.5 0 1 1 .708.708L3.707 
        7.5H14.5A.5.5 0 0 1 15 8z"/>
                </svg>
            </Button> */}


            {/* Top Strip */}
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#f0f0f0",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "bold",
                marginBottom: "20px"
            }}>
                <div>Patient ID: {row?.patientData?.patientClinicId || ""}</div>
                <div>Patient Name: {`${row?.patientData?.firstName} ${row?.patientData?.lastName}`}</div>
                <div>Bill Number: {row?.billNumber}</div>
                {row?.patientData?.phone && <div>Contact: {row?.patientData?.phone || ""}</div>}
            </div>

            {/* Bill Entries */}
            {billData.map((bill, index) => (
                <div key={index} style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "15px",
                    marginBottom: "20px",
                    background: "#e1e1e1"
                }}>
                    {/* Horizontal Layout */}
                    <div className="f-16" style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                    }}>
                        <div><label className="self-mb-0 fw-16">Billing Date:</label> <strong> {new Date(bill.billingDate).toLocaleString()} </strong> </div>
                        <div>Payment Mode: <strong> {bill.paymentMode} </strong></div>
                        <div>Status: <strong> {bill.paymentStatus} </strong></div>
                        <div>Total: <strong> {formatAmount(bill.totalAmount)} </strong></div>
                        <div>Total Amount Paid: <strong> {formatAmount(bill.totalPaidAmount)} </strong></div>
                        <div>Discount: <strong> {formatAmount(bill.totalDiscountAmount)}</strong> </div>
                        <div style={{ color: "red" }}>
                            Remaining: <strong> {formatAmount(bill.totalRemainingAmount)} </strong>
                        </div>
                    </div>

                    <h5 style={{ marginTop: "10px" }}>Services</h5>
                    <table border={1} style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderColor: "#ddd" }}>
                        <thead>
                            <tr style={{ backgroundColor: "#f9f9f9", textAlign: "left" }}>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Discount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bill.services.map(service => (
                                <tr key={service._id}>
                                    <td>{service.item}</td>
                                    <td>{service.quantity}</td>
                                    <td>{formatAmount(service.price)}</td>
                                    <td>{formatAmount(service.discount)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}

            {/* Bill Payment Table */}
            {billPaymentData.length > 0 && (
                <div style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "15px",
                    marginBottom: "20px",
                    background: "#e1e1e1"
                }}>
                    <h5 style={{ marginBottom: "10px" }}>Bill History</h5>
                    <table border={1} style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderColor: "#ddd" }}>
                        <thead>
                            <tr style={{ backgroundColor: "#fff", textAlign: "left" }}>
                                <th>Payment Date & Time </th>
                                <th>Payment Type</th>
                                <th>Amount Paid</th>
                                <th>Remaining Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {billPaymentData.map(payment => {
                                return (
                                    <tr key={payment._id}>
                                        <td>{moment(payment.paymentDate).format("DD/MM/YYYY, HH:mm:ss")}</td>
                                        <td>{payment.paymentType}</td>
                                        <td>{formatAmount(payment?.amountPaid)}</td>
                                        <td>{formatAmount(payment?.remainingAmount)}</td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    );
};

export default BillPaymentDetails;
